/**
 * @generated SignedSource<<b40604cad0e1f4c31abe56609a1fe545>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePackageInput = {
  name: string;
};
export type PackageListAddMutation$variables = {
  input: CreatePackageInput;
};
export type PackageListAddMutation$data = {
  readonly createPackage: {
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type PackageListAddMutation = {
  response: PackageListAddMutation$data;
  variables: PackageListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePackageResult",
    "kind": "LinkedField",
    "name": "createPackage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageListAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageListAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "076608e2961bda7babea312be46acc57",
    "id": null,
    "metadata": {},
    "name": "PackageListAddMutation",
    "operationKind": "mutation",
    "text": "mutation PackageListAddMutation(\n  $input: CreatePackageInput!\n) {\n  createPackage(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bc555ab619c454a9c29e09d8b5ca61b";

export default node;
